import { render } from "./GastroenterologiaForm.vue?vue&type=template&id=49ae238d&scoped=true"
import script from "./GastroenterologiaForm.vue?vue&type=script&lang=js"
export * from "./GastroenterologiaForm.vue?vue&type=script&lang=js"

import "./GastroenterologiaForm.vue?vue&type=style&index=0&id=49ae238d&scoped=true&lang=scss"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ae238d"]])

export default __exports__